/// <reference path="koyori.ts" />

/**
 * アコーディオンコンポーネントを表示するコンポーネントです。
 * <dl>
 * <dt>属性</dt>
 * <dd>exclusive: 設定されている場合は開くコンテンツは最高１つまでになります。</dd>
 * <dd>auto-open: エレメントロードURLに一致するaタグが存在すれば自動的に開きます</dd>
 * </dl>
 */
class KoyoriAccordion extends KoyoriElement {
	connectedCallback(): void {
		super.connectedCallback();

		if (this.getAttribute('auto-open') != null) {
			KoyoriElement.querySelectorAll(this, 'a').forEach(element => {
				let url = (<HTMLAnchorElement>element).href;
				if (url.split('#', 2)[0] != location.href.split('#', 2)[0]) {
					return;
				}

				element.classList.add('koy-disabled');

				let content = element.closest('koy-accordion-content');
				while (content != null) {
					content.setAttribute('open', '');
					let title = <HTMLElement>content.previousElementSibling;
					title.setAttribute('open', '');
					content = content.parentElement.closest('koy-accordion-content');
				}
			});
		}
	}
}
window.customElements.define('koy-accordion', KoyoriAccordion);

/**
 * アコーディオンコンポーネントのタイトル部分のコンポーネントです。
 * <dl>
 * <dt>属性</dt>
 * <dd>open: 開いている場合に付与されます。</dd>
 * </dl>
 */
class KoyoriAccordionTitle extends KoyoriElement {

	constructor() {
		super();
		this.addEventListener('click', () => {
			if (this.getAttribute('open') != null) {
				this.closeContent();
			} else {
				let parent = this.getParent();
				if (parent != null && parent.getAttribute('exclusive') != null) {
					KoyoriElement.children(parent).forEach(child => {
						if (child.tagName != 'KOY-ACCORDION-TITLE') {
							return;
						}
						(<KoyoriAccordionTitle>child).closeContent();
					});
				}
				this.openContent();
			}
		});
		this.addEventListener('transitionend', () => {
			setTimeout(() => {
				let content = this.getContent();
				if (content != null) {
					content.style.maxHeight = null;
				}
			}, 10);
		});
	}

	/**
	 * コンテンツを開きます。
	 */
	openContent() {
		let content = this.getContent();
		if (content != null) {
			content.style.maxHeight = content.scrollHeight + 'px';
		}

		setTimeout(() => {
			this.setAttribute('open', '');
			if (content != null) {
				content.setAttribute('open', '');
			}
		}, 10);
	}

	/**
	 * コンテンツを閉じます。
	 */
	closeContent() {
		let content = this.getContent();
		if (content != null) {
			content.style.maxHeight = content.scrollHeight + 'px';
		}

		setTimeout(() => {
			this.removeAttribute('open');
			if (content != null) {
				content.removeAttribute('open');
			}
		}, 10);
	}

	private getContent(): KoyoriAccordionContent {
		let content = this.nextElementSibling;
		if (content != null && content.tagName != 'KOY-ACCORDION-CONTENT') {
			content = null;
		}
		return <KoyoriAccordionContent>content;
	}

	private getParent(): KoyoriAccordion {
		let parent = this.closest('koy-accordion');
		return <KoyoriAccordion>parent;
	}

}
window.customElements.define('koy-accordion-title', KoyoriAccordionTitle);

/**
 * アコーディオンコンポーネントの内容部分のコンポーネントです。
 * <dl>
 * <dt>属性</dt>
 * <dd>open: 開いている場合に付与されます。</dd>
 * </dl>
 */
class KoyoriAccordionContent extends KoyoriElement {
}
window.customElements.define('koy-accordion-content', KoyoriAccordionContent);